import { render, staticRenderFns } from "./TableDriverId.vue?vue&type=template&id=b2945e96"
import script from "./TableDriverId.vue?vue&type=script&lang=js"
export * from "./TableDriverId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports